import React from 'react';
import { IonInput } from '@ionic/react';

import '../../styles/authentication/EntryField.scss';

// separated this into its own component bc there is a good amount of styling done

/**
 * Component for an entry field
 * @param {Object} props
 * @param {string} props.placeholder Placeholder text
 * @param {string} props.type Type of input
 * @param {string} [props.value] Value of the input
 * @param {function} props.setter Setter function for the input
 * @param {function} [props.onClick] onClick handler
 * * @param {function} [props.onFocus] onFocus handler
 * @param {string} [props.name] Name of input
 * @returns
 */
function EntryField({ placeholder, type, value, setter, name, readonly, onClick, onFocus }) {
  return (
    <IonInput
      className='entry-field'
      placeholder={placeholder}
      fill='outline'
      shape='round'
      type={type}
      name={name}
      value={value ?? ''}
      readonly={!!readonly}
      onClick={onClick}
      onFocus={onFocus}
      onIonInput={event => setter?.(event.detail.value)}
    />
  );
}

export default EntryField;
